import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import styles from './ResetPassword.module.scss';
import homeImage from '../../../assets/landingPage.png';
import logo from '../../../assets/Logo.png';
import { Input, Button } from '@src/components/ui';
const ResetPassword = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const uid = searchParams.get('uid');
    const [form, setForm] = useState({
        password: '',
        confirmPassword: '',
    });
    const [error, setError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [confirmPasswordError, setConfirmPasswordError] = useState('');
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    useEffect(() => {
        if (!token || !uid) {
            setError('Invalid or missing reset link. Please request a new password reset.');
        }
    }, [token, uid]);
    const handleChange = (field) => (value) => {
        if (passwordError)
            setPasswordError('');
        if (confirmPasswordError)
            setConfirmPasswordError('');
        if (error)
            setError('');
        setForm((prev) => ({ ...prev, [field]: value }));
    };
    const validateForm = () => {
        let isValid = true;
        if (!form.password || form.password.length < 8) {
            setPasswordError('Password must be at least 8 characters long');
            isValid = false;
        }
        if (form.password !== form.confirmPassword) {
            setConfirmPasswordError('Passwords do not match');
            isValid = false;
        }
        return isValid;
    };
    const handleSubmit = async () => {
        if (!validateForm())
            return;
        if (!token || !uid)
            return;
        setError('');
        setLoading(true);
        try {
            const response = await fetch('/api/v1/reset-password/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    token,
                    uid,
                    password: form.password,
                }),
            });
            const data = await response.json();
            if (response.ok && data.success) {
                setSuccessMessage('Password reset successfully! Redirecting to login...');
                setTimeout(() => navigate('/account/login'), 2000);
            }
            else {
                setError(data.message || 'Failed to reset password. Please try again.');
            }
        }
        catch (err) {
            setError('An error occurred. Please try again.');
        }
        setLoading(false);
    };
    const clearForm = () => {
        setError('');
        setPasswordError('');
        setConfirmPasswordError('');
        setForm({
            password: '',
            confirmPassword: '',
        });
    };
    return (_jsxs("div", { className: styles.createAccountWrapper, children: [successMessage && _jsx("div", { className: styles.successBanner, children: successMessage }), _jsx("img", { src: homeImage, alt: "Veterinary technology for animal care", className: styles.fullscreenBackground }), _jsxs("div", { className: styles.inputContainer, children: [_jsx(Link, { to: "/", className: styles.nav__logoWrapper, children: _jsx("img", { src: logo, style: { height: '50px', width: '217px' } }) }), _jsx("h2", { children: "Reset Password" }), _jsx("p", { className: styles.description, children: "Enter your new password below. Make sure it's at least 8 characters long." }), _jsx(Input, { label: !passwordError ? 'New Password' : `New Password: ${passwordError}`, type: "password", className: styles.inputItem, width: "100%", value: form.password, onChange: handleChange('password'), onFocus: () => (error || passwordError || confirmPasswordError) && clearForm(), error: !!passwordError || !!error }), _jsx(Input, { label: !confirmPasswordError ? 'Confirm New Password' : `Confirm Password: ${confirmPasswordError}`, type: "password", className: styles.inputItem, width: "100%", value: form.confirmPassword, onChange: handleChange('confirmPassword'), error: !!confirmPasswordError || !!error, onFocus: () => (error || passwordError || confirmPasswordError) && clearForm() }), error && _jsx("p", { className: styles.error, children: error }), _jsx(Button, { variant: "primaryV2", label: loading ? 'Resetting Password...' : 'Reset Password', size: "large", onClick: handleSubmit, disabled: loading || !token || !uid, className: styles.resetButton }), _jsx("div", { className: styles.loginContainer, children: _jsx(Link, { to: "/account/login", children: "Back to Login" }) })] })] }));
};
export default ResetPassword;
